var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import { ProgressBar } from '@uppy/react';
import FileInput from '@uppy/file-input';
import { Endpoints } from '@brg/api';
// import { MAX_FILES_COUNT } from '../../../editor/newel';
export function createUppy(fileRef, handler) {
    return new Uppy().use(Tus, {
        endpoint: "".concat(Endpoints.uploader, "/upload/"),
        chunkSize: 4194304
    })
        .use(FileInput, {
        target: fileRef.current,
        id: 'fileRef',
        pretty: true,
        inputName: 'files[]',
        locale: {}
    })
        .on('complete', function (result) {
        var _a;
        if (!!((_a = result === null || result === void 0 ? void 0 : result.successful) === null || _a === void 0 ? void 0 : _a.length)) {
            var results = result.successful.map(function (item, idx) {
                var _a;
                var url = item.uploadURL;
                var linkT = url.split('/');
                var lngh = linkT.length - 1;
                var id = linkT[lngh];
                var progress = (_a = item === null || item === void 0 ? void 0 : item.progress) === null || _a === void 0 ? void 0 : _a.percentage;
                return __assign(__assign({}, item), { progress: progress, url: id, id: id });
            });
            handler(results);
        }
    });
}
export var useUppyLoader = function (files, fileRef, handler, time) {
    var _a = useState([]), data = _a[0], setData = _a[1];
    var _b = useState([]), src = _b[0], setSrc = _b[1];
    var _c = useState([]), images = _c[0], setImages = _c[1];
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(false), uploadCompelete = _e[0], setUploadCompelete = _e[1];
    var onUploadComplete = useCallback(function (files) {
        setImages(files);
        setUploadCompelete(true);
        handler(uploadCompelete);
    }, [images, uploadCompelete]);
    var uppy = useState(function () { return createUppy(fileRef, onUploadComplete); })[0];
    useEffect(function () {
        if (files === null || files === void 0 ? void 0 : files.length) {
            var src_1 = [];
            uppy.reset();
            setIsLoading(true);
            files.forEach(function (file, idx) {
                var fr = new FileReader();
                try {
                    uppy.addFile({
                        source: 'file input',
                        name: file.name,
                        type: file.type || 'application/octet-stream',
                        data: file,
                        meta: {
                            contentType: file.type || 'application/octet-stream'
                        }
                    });
                }
                catch (err) {
                    if (err.isRestriction) {
                        setIsLoading(false);
                        // handle restrictions
                        console.error('Restriction error:', err);
                    }
                    else {
                        setIsLoading(false);
                        // handle other errors
                        console.error(err);
                    }
                }
                fr.onload = function () {
                    src_1.push({ name: file === null || file === void 0 ? void 0 : file.name, src: fr.result });
                };
                fr.readAsDataURL(file);
            });
            setSrc(src_1);
            uppy.upload();
        }
    }, [files, uppy]);
    useEffect(function () {
        if (images === null || images === void 0 ? void 0 : images.length) {
            setIsLoading(false);
            setData(images === null || images === void 0 ? void 0 : images.map(function (img) {
                var s = src === null || src === void 0 ? void 0 : src.find(function (s) { return s.name === img.name; });
                if (s) {
                    return __assign(__assign({}, img), { src: s === null || s === void 0 ? void 0 : s.src });
                }
                return img;
            }));
        }
    }, [src, images]);
    useEffect(function () {
        setData([]);
    }, [time]);
    return [uppy, data, isLoading];
};
//# sourceMappingURL=uppyLoader.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import { ProgressBar } from '@uppy/react';
import FileInput from '@uppy/file-input';
import { Endpoints } from '@brg/api';
// import { MAX_FILES_COUNT } from '../../../editor/newel';
export function createUppy(fileRef, handler) {
    return new Uppy().use(Tus, {
        endpoint: "".concat(Endpoints.uploader, "/upload/"),
        chunkSize: 4194304
    })
        .use(FileInput, {
        target: fileRef.current,
        id: 'fileRef',
        pretty: true,
        inputName: 'files[]',
        locale: {}
    })
        .on('complete', function (result) {
        var _a;
        if (!!((_a = result === null || result === void 0 ? void 0 : result.successful) === null || _a === void 0 ? void 0 : _a.length)) {
            var results = result.successful.map(function (item, idx) {
                var _a;
                var url = item.uploadURL;
                var linkT = url.split('/');
                var lngh = linkT.length - 1;
                var id = linkT[lngh];
                var progress = (_a = item === null || item === void 0 ? void 0 : item.progress) === null || _a === void 0 ? void 0 : _a.percentage;
                return __assign(__assign({}, item), { progress: progress, url: id, id: id });
            });
            handler(results);
        }
    });
}
export var useUppyLoader = function (files, fileRef, handler, time) {
    var _a = useState([]), data = _a[0], setData = _a[1];
    var _b = useState([]), src = _b[0], setSrc = _b[1];
    var _c = useState([]), images = _c[0], setImages = _c[1];
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(false), uploadCompelete = _e[0], setUploadCompelete = _e[1];
    var onUploadComplete = useCallback(function (files) {
        setImages(files);
        setUploadCompelete(true);
        handler(uploadCompelete);
    }, [images, uploadCompelete]);
    var uppy = useState(function () { return createUppy(fileRef, onUploadComplete); })[0];
    useEffect(function () {
        if (files === null || files === void 0 ? void 0 : files.length) {
            var src_1 = [];
            uppy.reset();
            setIsLoading(true);
            files.forEach(function (file, idx) {
                var fr = new FileReader();
                try {
                    uppy.addFile({
                        source: 'file input',
                        name: file.name,
                        type: file.type || 'application/octet-stream',
                        data: file,
                        meta: {
                            contentType: file.type || 'application/octet-stream'
                        }
                    });
                }
                catch (err) {
                    if (err.isRestriction) {
                        setIsLoading(false);
                        // handle restrictions
                        console.error('Restriction error:', err);
                    }
                    else {
                        setIsLoading(false);
                        // handle other errors
                        console.error(err);
                    }
                }
                fr.onload = function () {
                    src_1.push({ name: file === null || file === void 0 ? void 0 : file.name, src: fr.result });
                };
                fr.readAsDataURL(file);
            });
            setSrc(src_1);
            uppy.upload();
        }
    }, [files, uppy]);
    useEffect(function () {
        if (images === null || images === void 0 ? void 0 : images.length) {
            setIsLoading(false);
            setData(images === null || images === void 0 ? void 0 : images.map(function (img) {
                var s = src === null || src === void 0 ? void 0 : src.find(function (s) { return s.name === img.name; });
                if (s) {
                    return __assign(__assign({}, img), { src: s === null || s === void 0 ? void 0 : s.src });
                }
                return img;
            }));
        }
    }, [src, images]);
    useEffect(function () {
        setData([]);
    }, [time]);
    return [uppy, data, isLoading];
};
//# sourceMappingURL=uppyLoader.js.map